const Tdata = [
	{
		cover: "./images/top/electrical-category.jpeg",
		para: "Electrical",
		desc: "3k orders this week",
	},
	{
		cover: "./images/top/masonry-category.png",
		para: "Masonry",
		desc: "4k orders this week",
	},
	{
		cover: "./images/top/steel-category.jpeg",
		para: "Steel",
		desc: "6k orders this week",
	},
	{
		cover: "./images/top/roofing-category.png",
		para: "Roofing",
		desc: "3k orders this week",
	},
	{
		cover: "./images/top/concreting-category.png",
		para: "Concreting",
		desc: "4k orders this week",
	},
	{
		cover: "./images/top/flooring-category.png",
		para: "Flooring",
		desc: "6k orders this week",
	},
	{
		cover: "./images/top/framing-category.png",
		para: "Framing",
		desc: "3k orders this week",
	},
];

export default Tdata;
